module.exports = __webpack_public_path__ + "img/error.a6f2a2c0.png";